<google-chart [options]="options" [type]="type" [data] = "data" [columns] = "chartColumns"  [dynamicResize]="true" ></google-chart>